const userTypes = {
  LOGIN_USER_START: 'LOGIN_USER_START',
  AUTO_LOGIN_USER_START: 'AUTO_LOGIN_USER_START',
  LOGOUT_USER_START: 'LOGOUT_USER_START',
  RESET_PASSWORD_START: 'RESET_PASSWORD_START',
  SIGNUP_START: 'SIGNUP_START',
  VERIFY_USER_CREDENTIALS_START: 'VERIFY_USER_CREDENTIRALS_START',
  VALIDATE_SMS_VERIFICATION_CODE_START: 'VALIDATE_SMS_VERIFICATION_CODE_START',
  RESEND_VERIFICATION_SMS_START: 'RESEND_VERIFICATION_SMS_START',
  VALIDATE_SMS_AND_REDIRECT_TO_PAYMENT_START:
    'VALIDATE_SMS_AND_REDIRECT_TO_PAYMENT_START',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  RESET_STORE_DATA: 'RESET_STORE_DATA',

  POST_USER_DATA_OF_OTV: 'POST_USER_DATA_OF_OTV',
  POST_USER_DATA_OF_OTV_SUCCESS: 'POST_USER_DATA_OF_OTV_SUCCESS',
  POST_USER_DATA_OF_OTV_FAILURE: 'POST_USER_DATA_OF_OTV_FAILURE',
  REDIRECT_TO_IMPORT_CODE: 'REDIRECT_TO_IMPORT_CODE',
  LOGIN_USER_ONE_TIME_CODE: 'LOGIN_USER_ONE_TIME_CODE',

  SEND_VERIFICATION_SMS: 'SEND_VERIFICATION_SMS',
};

export default userTypes;
